import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const CalendarMonthIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faCalendarDay} color={props.color || 'black'} />
  )
}
